import { atom } from 'jotai'

/**
 * Atom representing the current page of the company grid.
 */
export const companyGridCurrentPageAtom = atom(0)

/**
 * Atom representing the search text input in the company section.
 */
export const companySearchTextfieldAtom = atom('')

/**
 * Atom representing the filters applied to companies.
 */
export const companyFiltersAtom = atom<{
    listed: { value: ('all' | 'only-listed' | 'only-unlisted')[] }
    marketSize: { value: number[]; maxValue: number; includeGreatValues: boolean; hasMaxValueSet: boolean }
    marketplaces: { value: string[] }
    onlyInWatchLists: { value: false }
    sectors: { value: string[] }
}>({
    listed: { value: ['all'] },
    marketSize: { value: [0, 300], maxValue: 300, includeGreaterValues: true, hasMaxValueSet: true },
    sectors: { value: [] },
    marketplaces: {
        value: [],
    },
    onlyInWatchLists: { value: false },
})
